'use client';

import { FC, useMemo, useState } from 'react';

import { CMSFaq } from '@/api/cms/base';
import { QuestionAnswerItem } from '@/components/QuestionAnswerItem';
import { ThemeMode } from '@/helpers/enums';
import {
  getDefaultSection,
  getMatchingSection,
} from '@/helpers/userAccessSection';
import { useCommonStore } from '@/store/commonStore';

import { ScFAQSection } from './styled';
import { ScQuestionAnswer } from '@/components/footerStaticPages/faq/styled';

interface FAQSectionProps {
  title?: string;
  sections: CMSFaq[];
}

export const FAQSection: FC<FAQSectionProps> = ({ title, sections }) => {
  const user = useCommonStore.use.user();
  const [activeAnswerItem, setActiveAnswerItem] = useState<number | null>(null);

  const items = useMemo(() => {
    const section = getMatchingSection(sections, user);
    return section ? section.items : getDefaultSection(sections)?.items;
  }, [sections, user]);

  if (!items) return null;

  return (
    <ScFAQSection>
      {title && <h2>{title}</h2>}
      <ScQuestionAnswer>
        <div className="questions">
          {items.map(({ question, answer }, index) => (
            <QuestionAnswerItem
              key={index}
              title={question}
              description={answer}
              mode={ThemeMode.Dark}
              isOpen={index === activeAnswerItem}
              handleOpen={() =>
                setActiveAnswerItem(index === activeAnswerItem ? null : index)
              }
            />
          ))}
        </div>
      </ScQuestionAnswer>
    </ScFAQSection>
  );
};
